const baseURL = 'https://comercio.mixkatalogo.com/';

export default baseURL;
